import { getValueForDevice, updateDepositUrl } from '../../utils';
import './styles.scss';

export const depositPlugin = {
  beforeRender({ header, params, productConfig }) {
    header.actions.children.unshift({
      type: '@sitebase/deposit-button',
      children: [],
      data: {
        id: 'pi-header__deposit-button',
        eventSource: params.eventSource,
      },
    });

    header.actions.children.push({
      type: '@sitebase/deposit',
      data: {
        amount: params.amount,
        amountButtons: params.amountButtons,
        countryLevelConfig: params.countryLevelConfig,
        blockedSchemesUrl: params.blockedSchemesUrl,
        contentUrl: params.contentUrl,
        depositLimitsPageUrl: params.depositLimitsPageUrl,
        chatUrl: params.chatUrl,
        currency: params.currency,
        depositUrl: updateDepositUrl(getValueForDevice(params.depositUrl)),
        hideDLTforCountryCodes: params.hideDLTforCountryCodes,
        showMiniTrackerForCountryCodes: params.showMiniTrackerForCountryCodes,
        showDepositLimitsLinkForCountryCodes: params.showDepositLimitsLinkForCountryCodes,
        forceHideDLT: params.forceHideDLT,
        obUrl: getValueForDevice(params.obUrl),
        pmtApiUrl: params.pmtApiUrl,
        pmtMethodsStrategy: params.pmtMethodsStrategy,
        pmtSource: getValueForDevice(params.pmtSource),
        showCloseButton: params.showCloseButton,
        showOtherDepositMethodsLink: params.showOtherDepositMethodsLink,
        tdsTermUrl: params.tdsTermUrl,
        tdsTermUrlV2: params.tdsTermUrlV2,
        jurisdiction: productConfig.jurisdiction,
        disableApplePay: params.disableApplePay,
      },
      children: [],
    });
  },
};
